@if (pageReady) {
    <div
        [froalaEditor]="froalaOptions"
        [(froalaModel)]="froalaEditingValue"
        [id]="editorID"
        #editorCmp
    ></div>

    @if (contextMenu) {
        <cerrix-contextmenu [menu]="contextMenu" [container]="editorCmp"></cerrix-contextmenu>
    }

    <div class="modal fade" tabindex="-1" role="dialog" #pdfModal>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ "cerrixEditor.pdfSelector.title" | transloco }}</h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        [attr.aria-label]="'cerrixEditor.pdfSelector.close' | transloco"
                    ></button>
                </div>
                @if (pdfs) {
                    <div class="modal-body">
                        <div>
                            <table class="table-cerrix bordered rounded centered hoverable striped">
                                <thead>
                                    <tr class="row">
                                        <th class="col-md-4">
                                            {{ "cerrixEditor.pdfSelector.nameColumn" | transloco }}
                                        </th>
                                        <th class="col-md-4">
                                            {{
                                                "cerrixEditor.pdfSelector.descriptionColumn"
                                                    | transloco
                                            }}
                                        </th>
                                        <th class="col-md-2">
                                            {{ "cerrixEditor.pdfSelector.uploaderColumn" | transloco }}
                                        </th>
                                        <th class="col-md-2">
                                            {{ "cerrixEditor.pdfSelector.dateColumn" | transloco }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (data of pdfs; track data) {
                                        <tr
                                            class="row"
                                            (click)="selectedPdf = data"
                                            [ngClass]="{
                                                highlighted:
                                                    selectedPdf != null &&
                                                    selectedPdf.guid == data.guid,
                                            }"
                                        >
                                            <td class="col-md-4">{{ data.name }}</td>
                                            <td class="col-md-4">{{ data.description }}</td>
                                            <td class="col-md-2">{{ data.updatedBy }}</td>
                                            <td class="col-md-2">
                                                {{ data.updatedOn | dateTimeFormat }}
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        {{ "cerrixEditor.pdfSelector.close" | transloco }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        [disabled]="!selectedPdf"
                        (click)="insertPdf()"
                    >
                        {{ "cerrixEditor.pdfSelector.insert" | transloco }}
                    </button>
                </div>
            </div>
        </div>
    </div>
}
